<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Fluid Tracking</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="!isAuditorRole" @click="buttonState.action" class="white--text" dark text>
              {{ buttonState.name }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-alert dense type="error" v-if="showError">
              Please select Fluid Tracking Type
            </v-alert>
            <v-row>
              <v-col cols="12" sm="12">
                <v-radio-group v-model="items.hasRecord" :row="!isSmallScreen">
                  <v-radio label="Fluid Tracking" :value="true"></v-radio>
                  <v-radio label=" No Fluid Tracking" :value="false"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" v-if="items.hasRecord" class="ma-0 pa-0">
                <v-card
                  class="pa-5"
                  v-for="(fi, i) in items.fluidIntakes"
                  :key="i"
                >
                  <v-row justify="end" v-if="items.fluidIntakes.length > 1">
                    <v-btn color="error" x-small fab @click="deleteItem(i)">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="fi.fluid"
                        label="Fluid Intake"
                        :items="fluids"
                        item-text="name"
                        item-value="initial"
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="fi.location"
                        label="Location"
                        :items="locations"
                        item-text="name"
                        item-value="initial"
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="fi.cup"
                        label="No of Cups"
                        type="number"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
                <v-row justify="end" class="mt-3">
                  <v-btn color="primary" small @click="addFluidIntake">
                    add
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    row: {
      type: Number,
    },
    isAuditorRole: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      // fluids: [
      //   {
      //     type: "Type 1",
      //     image: "/fluidTrackingFluids/01 Glass Full (16 fl oz).png",
      //     description: "Glass Full (16 fl oz)",
      //   },
      //   {
      //     type: "Type 2",
      //     image: "/fluidTrackingFluids/02 Glass Half Full (8 fl oz).png",
      //     description: "Glass Half Full (8 fl oz)",
      //   },
      //   {
      //     type: "Type 3",
      //     image: "/fluidTrackingFluids/03 Bottle Full (17 fl oz).png",
      //     description: "Bottle Full (17 fl oz)",
      //   },
      //   {
      //     type: "Type 3",
      //     image: "/fluidTrackingFluids/04 Bottle Half Full (8.5 fl oz).png",
      //     description: "Bottle Half Full (8.5 fl oz)",
      //   },
      // ],
      items: {
        hasRecord: null,
        fluidIntakes: [{}],
      },
      selectedType: null,
      isSelectFT: null,
      selectedFTType: "",
      showError: false,
      ftId: "",
      fluids: [
        { name: "Water", initial: "W" },
        { name: "Milk", initial: "M" },
        { name: "Juice", initial: "J" },
        { name: "Soda", initial: "S" },
      ],
      locations: [
        { name: "Home", initial: "H" },
        { name: "Employment/School", initial: "E/S" },
      ],
    };
  },
  computed: {
    isActive() {
      return (index) => index === this.selectedType;
    },

    buttonState() {
      let state = "";
      if (this.ftId === "") {
        state = {
          name: "save",
          action: this.save,
          color: "#259647",
        };
      } else {
        state = {
          name: "update",
          action: this.update,
          color: "blue darken-1",
        };
      }
      return state;
    },

    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    show() {
      this.dialog = !this.dialog;
    },

    save() {
      if (this.items.hasRecord === null) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 1000);
        return;
      }

      const data = {
        ...this.items,
        date: new Date(),
        row: this.row,
        fluidIntakes: this.items.hasRecord ? this.items.fluidIntakes : [{}],
      };

      this.$emit("save-item", data);
      this.show();
      this.close()
    },
    update() {
      if (this.items.hasRecord === null) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 1000);
        return;
      }

      const data = {
        ...this.items,
        date: new Date(),
        fluidIntakes: this.items.hasRecord ? this.items.fluidIntakes : [{}],
      };

      this.$emit("update-item", data);
      this.show();
      this.close()
    },
    populateData(data) {
      this.$nextTick(() => {
        this.ftId = data._id;
        this.items.hasRecord = data.hasRecord;
        this.items.fluidIntakes = data.fluidIntakes;
      });
    },
    clear() {
      this.items.hasRecord = null;
      this.items.fluidIntakes = [{}];
      this.ftId = "";
    },

    deleteItem(i) {
      this.items.fluidIntakes.splice(i, 1);
    },
    addFluidIntake() {
      this.items.fluidIntakes.push({});
    },
    close() {
      this.dialog = false;
      this.clear();
    },
  },
};
</script>

<style scoped>
.scroll-x {
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
}

.fluid-card {
  background: rgb(255, 255, 255);
  background: linear-gradient(
    -180deg,
    rgb(255, 255, 255) 0%,
    rgb(255, 255, 255) 100%
  );
}

.fluid-card:hover {
  /* background: #e2d110; */
  cursor: pointer;
}

.active {
  background: #e2d110;
}
</style>
